/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { SelectMenuItem, Text, useTheme, VFlow } from 'bold-ui'
import { SelectDownshiftMenuProps } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import { Fragment } from 'react'

import { ExameSolicitadoSelectModel } from '../../model-anexoArquivos'

interface ExameSolicitadoSelectItemProps extends SelectDownshiftMenuProps<ExameSolicitadoSelectModel> {
  readonly item: ExameSolicitadoSelectModel
  readonly index: number
}

export function ExameSolicitadoSelectItem({ item, index, downshift }: ExameSolicitadoSelectItemProps) {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Fragment>
      {item.headerText && (
        <div css={styles.container}>
          <Text fontWeight='bold' color='primary'>
            {item.headerText}
          </Text>
        </div>
      )}
      <SelectMenuItem selected={downshift.highlightedIndex === index} {...downshift.getItemProps({ item })}>
        <VFlow vSpacing={0}>
          <Text fontWeight='bold'>{item.descricao}</Text>
          <Text size='small'>
            {`Código ${item.codigo} | Solicitado em ${item.dataSolicitacao}`}
            {item.idProfissional ? ` por ${item.nomeProfissional} | ${item.cbo}` : ''}
          </Text>
        </VFlow>
      </SelectMenuItem>
    </Fragment>
  )
}

const createStyles = (theme) => ({
  container: css`
    background-color: ${theme.pallete.primary.c90};
    padding: 0.5rem;
  `,
})
